export default __webpack_public_path__ + "static/media/Frame10.c7a07543.jpg";